// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobMenu_wrapper__\\+9\\+XP {
  background-color: #1B1E23;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  left: 0;
  padding-bottom: 24px;
  padding-top: 18px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2;
}
.MobMenu_wrapper__\\+9\\+XP .MobMenu_container__XYZWW {
  margin: 0 auto;
  width: 90%;
}
.MobMenu_wrapper__\\+9\\+XP .MobMenu_container__XYZWW .MobMenu_header__KYllo {
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.MobMenu_wrapper__\\+9\\+XP .MobMenu_container__XYZWW .MobMenu_header__KYllo .MobMenu_right__w5yde {
  font-size: 20px;
  font-weight: 400;
  font-style: normal;
  align-items: center;
  color: #ffffff;
  gap: 24px;
  display: flex;
}
.MobMenu_wrapper__\\+9\\+XP .MobMenu_container__XYZWW .MobMenu_header__KYllo .MobMenu_right__w5yde .MobMenu_lang__uhU9V {
  display: flex;
  gap: 4px;
}
.MobMenu_wrapper__\\+9\\+XP .MobMenu_container__XYZWW .MobMenu_header__KYllo .MobMenu_right__w5yde .MobMenu_yellow__ZNOLw {
  color: #EAD40C;
}
.MobMenu_wrapper__\\+9\\+XP .MobMenu_container__XYZWW .MobMenu_profile__wb7xc {
  border-bottom: 1px solid rgba(220, 220, 220, 0.1019607843);
}
.MobMenu_wrapper__\\+9\\+XP .MobMenu_container__XYZWW .MobMenu_profile__wb7xc .MobMenu_info__aQEGm {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  color: #ffffff;
  display: flex;
  gap: 8px;
  margin-top: 40px;
}
.MobMenu_wrapper__\\+9\\+XP .MobMenu_container__XYZWW .MobMenu_profile__wb7xc .MobMenu_info__aQEGm img {
  width: 48px;
}
.MobMenu_wrapper__\\+9\\+XP .MobMenu_container__XYZWW .MobMenu_profile__wb7xc .MobMenu_points__Y50iX {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  color: #EAD40C;
  margin-top: 16px;
  margin-bottom: 24px;
}
.MobMenu_wrapper__\\+9\\+XP .MobMenu_container__XYZWW .MobMenu_menu__fk18q {
  font-size: 20px;
  font-weight: 500;
  font-style: normal;
  color: #fff;
  margin-top: 40px;
}
.MobMenu_wrapper__\\+9\\+XP .MobMenu_container__XYZWW .MobMenu_menu__fk18q .MobMenu_menuItem__HgXEG {
  margin-bottom: 8px;
  padding-bottom: 8px;
  padding-top: 8px;
}
.MobMenu_wrapper__\\+9\\+XP .MobMenu_btns__z8TXM {
  margin: 0 auto;
  width: 90%;
}
.MobMenu_wrapper__\\+9\\+XP .MobMenu_btns__z8TXM .MobMenu_btn__FkPOX {
  margin-bottom: 20px;
}
.MobMenu_wrapper__\\+9\\+XP .MobMenu_btns__z8TXM button {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/MobMenu/MobMenu.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAEA;EACE,yBAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,OAAA;EACA,oBAAA;EACA,iBAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,UAAA;AADF;AAGE;EACE,cAAA;EACA,UAAA;AADJ;AAGI;EACE,mBAAA;EACA,aAAA;EACA,8BAAA;AADN;AAGM;ECkBJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDjBM,mBAAA;EACA,cAAA;EACA,SAAA;EACA,aAAA;AAAR;AAEQ;EACE,aAAA;EACA,QAAA;AAAV;AAGQ;EACE,cAAA;AADV;AAMI;EACE,0DAAA;AAJN;AAMM;ECVJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDWM,mBAAA;EACA,cAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;AAHR;AAKQ;EACE,WAAA;AAHV;AAOM;ECZJ,eAAA;EACA,gBAAA;EACA,kBAAA;EDaM,cAAA;EACA,gBAAA;EACA,mBAAA;AAJR;AAQI;ECjCF,eAAA;EACA,gBAAA;EACA,kBAAA;EDkCI,WAAA;EACA,gBAAA;AALN;AAOM;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;AALR;AAUE;EACE,cAAA;EACA,UAAA;AARJ;AAUI;EACE,mBAAA;AARN;AAWI;EACE,WAAA;AATN","sourcesContent":["@import '../../assets/styles/global.scss';\n\n.wrapper {\n  background-color: #1B1E23;\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  left: 0;\n  padding-bottom: 24px;\n  padding-top: 18px;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 2;\n\n  .container {\n    margin: 0 auto;\n    width: 90%;\n\n    .header {\n      align-items: center;\n      display: flex;\n      justify-content: space-between;\n\n      .right {\n        @include subtitle5;\n\n        align-items: center;\n        color: #ffffff;\n        gap: 24px;\n        display: flex;\n\n        .lang {\n          display: flex;\n          gap: 4px;\n        }\n\n        .yellow {\n          color: #EAD40C;\n        }\n      }\n    }\n  \n    .profile {\n      border-bottom: 1px solid #DCDCDC1A;\n     \n      .info {\n        @include subtitle4m;\n\n        align-items: center;\n        color: #ffffff;\n        display: flex;\n        gap: 8px;\n        margin-top: 40px;\n\n        img {\n          width: 48px;\n        }\n      }\n\n      .points {\n        @include subtitle6m;\n\n        color: #EAD40C;\n        margin-top: 16px;\n        margin-bottom: 24px;\n      }\n    }\n\n    .menu {\n      @include subtitle4m;\n\n      color: #fff;\n      margin-top: 40px;\n\n      .menuItem {\n        margin-bottom: 8px;\n        padding-bottom: 8px;\n        padding-top: 8px;\n      }\n    }\n  }\n\n  .btns {\n    margin: 0 auto;\n    width: 90%;\n\n    .btn {\n      margin-bottom: 20px;\n    }\n\n    button {\n      width: 100%;\n    }\n  }\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `MobMenu_wrapper__+9+XP`,
	"container": `MobMenu_container__XYZWW`,
	"header": `MobMenu_header__KYllo`,
	"right": `MobMenu_right__w5yde`,
	"lang": `MobMenu_lang__uhU9V`,
	"yellow": `MobMenu_yellow__ZNOLw`,
	"profile": `MobMenu_profile__wb7xc`,
	"info": `MobMenu_info__aQEGm`,
	"points": `MobMenu_points__Y50iX`,
	"menu": `MobMenu_menu__fk18q`,
	"menuItem": `MobMenu_menuItem__HgXEG`,
	"btns": `MobMenu_btns__z8TXM`,
	"btn": `MobMenu_btn__FkPOX`
};
export default ___CSS_LOADER_EXPORT___;
